<script setup lang="ts">
import type { DeepPartial } from '#ui/types'
import type { AsideLink } from '#ui-pro/types'
import type { PropType } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  class: {
    default: undefined,
    type: [
      String,
      Object,
      Array,
    ] as PropType<any>,
  },
  links: {
    default: () => [],
    type: Array as PropType<AsideLink[]>,
  },
  ui: {
    default: () => ({}),
    type: Object as PropType<DeepPartial<typeof config>>,
  },
})

const config = {
  top: {
    body: 'bg-background relative pointer-events-auto flex -mx-4 px-4',
    footer: 'h-8 bg-gradient-to-b from-background -mx-4 px-4',
    header: 'h-8 bg-background -mx-4 px-4',
    wrapper: 'sticky -top-8 -mt-8 pointer-events-none z-[1]',
  },
  wrapper: 'py-8 lg:px-4 lg:-mx-4',
}

const { attrs, ui } = useUI('aside', toRef(props, 'ui'), config, toRef(props, 'class'), true)
</script>

<template>
  <aside
    :class="ui.wrapper"
    v-bind="attrs"
  >
    <div class="relative">
      <div
        v-if="$slots.top"
        :class="ui.top.wrapper"
      >
        <div :class="ui.top.header" />

        <div :class="ui.top.body">
          <slot name="top" />
        </div>

        <div :class="ui.top.footer" />
      </div>

      <slot name="links">
        <AsideLinks :links="links" />
      </slot>

      <slot />

      <slot name="bottom" />
    </div>
  </aside>
</template>
